
import { registerBlockType } from '@quillforms/blocks';
import EmailBlock from './email';

registerBlockType('custom-email', {
  supports: {
		editable: true,
		required: true,
		attachment: true,
		description: true,
		placeholder: true,
		defaultValue: true,
		logic: true,
		theme: true
	},
	attributes: {},
	logicalOperators: [
		'is',
		'is_not',
		'starts_with',
		'contains',
		'ends_with',
		'not_contains'
	],

  display: (props) => <EmailBlock {...props} />
});

